import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError, QueryFilters } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metric/medianMfa';

const fetchMedianMfa = async (filters: QueryFilters): Promise<number> => {
    const data = await apiGet<number>(`${API_BASE_URL}${END_POINT}`, buildUniversalMfaQueryParams(filters));
    return data;
};

export const useMedianMfa = (filters: QueryFilters): UseQueryResult<number, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.medianMfa(filters),
        queryFn: () => fetchMedianMfa(filters)
    });
};
